import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { BusinessFileNames } from '../../../enums/business-file-names';
import { SettlementFileNames } from '../../../enums/settlement-file-names';
import BaseFileUpload from './base-file-upload.button';
import './file-upload.styles.css';

interface Props {
  form: UseFormReturnType<any>;
  value: BusinessFileNames | SettlementFileNames;
  dataCy?: string;
}
function UpdateFileUpload(props: Props) {
  const { form, value, dataCy } = props;

  return <BaseFileUpload form={form} value={value} dataCy={dataCy} />;
}

export default UpdateFileUpload;
